module.exports = __webpack_public_path__ + "static/media/adriana.b41f0316.JPG";